import { Component, OnInit, TemplateRef } from '@angular/core';
import { NotaCreditoService } from '../../../services/nota-credito.service';
import { NotaCredito } from '../../../models/nota-credito';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SweetMessage } from '../../../config/sweet-message';
import { SessionService } from '../../../services/session.service';
import { ConfigService } from '../../../config/config-service';
import { ReporteModalComponent } from '../../modals/reporte-modal/reporte-modal.component';
import { ReenviarCorreoComponent } from '../../modals/reenviar-correo/reenviar-correo.component';
import { NotacreditoModalComponent } from '../../modals/notacredito-modal/notacredito-modal.component';
import { ConfirmacionAnulacionModalComponent } from '../../modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { Compra } from '../../../models/compra';
import * as moment from 'moment';
import { NotacreditoCompraModalComponent } from '../../modals/nota-credito-compra-modal/notacredito-compra-modal.component';
import { environment } from '../../../../environments/environment';
import { AsientoContableDetalleModalComponent } from '../../modals/asiento-contable-modal/asiento-contable-detalle-modal.component';

@Component({
  selector: 'app-nota-credito-compra-list',
  templateUrl: './nota-credito-compra-list.component.html',
  styleUrls: ['./nota-credito-compra-list.component.css'],
  providers: [NotaCreditoService]
})
export class NotaCreditoCompraListComponent implements OnInit {
	public notas: Array<NotaCredito>;
	public loading: boolean = false;
	public bsModalRef: BsModalRef;
	public bsModalRef2: BsModalRef;
	public tipo: String;
	public fecha_emision;
	public nota:NotaCredito;
	public msg: SweetMessage;
	public compra:Compra;
	public Mod_FactElec: string;
	public config: ConfigService;
	public nota_credito_anulada: NotaCredito;
	public observacion: String;
	public factelec_api: String;
	public Mod_Contabilidad: string;
	constructor(
		private notaCreditoService: NotaCreditoService,
		private modalService: BsModalService,
		private ss: SessionService,
	) {
		this.notas = [];
		this.nota = new NotaCredito();
		this.tipo = "";
		this.fecha_emision = moment(this.fecha_emision);
		this.nota.usuario_id = 
		this.Mod_FactElec = this.ss.getData("mod_felectronica");
		this.config = new ConfigService();
		this.factelec_api = environment.factelec_api;
		this.Mod_Contabilidad = this.ss.getData("mod_contabilidad");
	}

	ngOnInit() {
		this.msg = new SweetMessage();
		let p1 = this.getNotasCredito();
		Promise.all([p1]).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}
	// validarUsuario(){
	// 	if (this.compra.usuario_id == "Admin" && this.compra.fecha_emision ) {

	// 	}

	// }
	getNotasCredito(){
		let usuario_id = this.ss.getData('usuario_id');

		let fecha_emision = moment(this.fecha_emision).format("YYYY-MM-DD");
		let qs = "&fecha_emision=" + fecha_emision + "&usuario_id=" + usuario_id + "&tipo=C";
		// let tipo_comprobante_id = "";
		// 	if(this.Mod_FactElec){
		// 		tipo_comprobante_id = "9";
		// 	}
		// 	else{
		// 		tipo_comprobante_id = "8";
		// 	}
		//&tipo_comprobante_id="+ tipo_comprobante_id
		return new Promise((resolve, reject) => {
			this.notaCreditoService.getAll("?embed=tipocomprobante,asientocontable,estadobitacora,compra?embed=proveedor&status=A" + qs).subscribe(
				res => {
					this.notas = res.data;
					this.nota = res.data;
					resolve();
				},
				err => {
					this.notas = [];
					reject();
				}
			);
		});
	}

	getNumero(nota_credito: NotaCredito){
		return nota_credito.serie + "-" + nota_credito.punto_emision + "-" + nota_credito.secuencial;
	}

	getNumeroCompra(compra: NotaCredito){
		return compra.serie + "-" + compra.punto_emision + "-" + compra.secuencial;
	}

	onShow(id){
		const initialState = {nota_credito_id: id};
		this.bsModalRef = this.modalService.show(NotacreditoCompraModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}
	onShowAsiento(asiento){
		const initialState = {asiento_id: asiento.id, tipo_transaccion_contabilidad_id: asiento.tipo_transaccion_contabilidad_id};
		this.bsModalRef = this.modalService.show(AsientoContableDetalleModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
  	}

	onPrint(id){
		/*const initialState = {nota_credito_id: id};
		this.bsModalRef = this.modalService.show(FacturaModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));*/
	}

	onStatusElectronica(nota_credito){
		let msn = "";
		msn += "<p>Estado de nota de crédito electrónica</p>";
        msn += "<p><b style='font-size:24px;'>"+nota_credito.estadobitacora.descripcion+"</b></p>";

        this.msg.showMessage('single-message', msn);
	}

	OnReenviar(nota_credito){
        const initialState = { nombre: nota_credito.venta.cliente.nombre_comercial, correo: nota_credito.venta.cliente.correo, autorizacion: nota_credito.numero_autorizacion };
		this.bsModalRef = this.modalService.show(ReenviarCorreoComponent, Object.assign({}, {initialState}));
    }

	onReport(nota_credito){
		let params = [];
		if( this.tipo ){
            params["tipo"] = this.nota.tipo_comprobante_id;
        }
        const initialState = {host_api: this.factelec_api, route: "/" + this.ss.getData('fact_user') + "/ride/" + nota_credito.numero_autorizacion, qs: "?tk=" + this.ss.getData('fact-api-token')};
		this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

	onXML(nota_credito){
		const initialState = {host_api: this.factelec_api, route: "/" + this.ss.getData('fact_user') + "/xml/" + nota_credito.numero_autorizacion, qs: "?tk=" + this.ss.getData('fact-api-token')};
		this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

	CodEst(nota_credito){
		let cod_ests = ['NAT', 'NFIR', 'NLOG', 'DEV', 'TOT', 'FEC'];
		let result = cod_ests.filter(cod_est => cod_est === nota_credito.cod_est);

		if( result.length > 0 ){
			return 'btn-danger';
		}

		cod_ests = ['VAL', 'PPR', 'EP'];
		result = cod_ests.filter(cod_est => cod_est === nota_credito.cod_est);

		if( result.length > 0 ){
			return 'btn-warning';
		}

		cod_ests = ['AUT'];
		result = cod_ests.filter(cod_est => cod_est === nota_credito.cod_est);

		if( result.length > 0 ){
			return 'btn-success';
		}
	}

	openModalObservacion(template: TemplateRef<any>, nota_credito: NotaCredito) {
		
		this.observacion = nota_credito.observacion;
		this.nota_credito_anulada = nota_credito;
		this.bsModalRef = this.modalService.show(template);
		this.bsModalRef2 = this.bsModalRef;
		
		// if(nota_credito.tipo_comprobante_id.toString() === "9" ){
		// 	let preg = "Recuerda que para anular algún comprobante primero debes anularlo desde <a href='https://declaraciones.sri.gob.ec/tuportal-internet/' target='_blank'>https://declaraciones.sri.gob.ec/tuportal-internet/</a>, posteriormente podrás anularlo desde esta opción. ¿Estás seguro que deseas continuar?";
		// 	const initialState = { Pregunta: preg, Respuesta:false };
		// 	this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));

		// 	this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
		// 		if(Respuesta == true){
		// 			this.observacion = nota_credito.observacion;
		// 			this.nota_credito_anulada = nota_credito;
		// 			this.bsModalRef = this.modalService.show(template);
		// 			this.bsModalRef2 = this.bsModalRef;
		// 		}
		// 	});
		// }
		// else{
		// 	this.observacion = nota_credito.observacion;
		// 	this.nota_credito_anulada = nota_credito;
		// 	this.bsModalRef = this.modalService.show(template);
		// 	this.bsModalRef2 = this.bsModalRef;
		// }
	}

	anularNota(){
		this.bsModalRef2.hide();
		let preg = "¿Esta seguro de querer eliminar el documento?";
		const initialState = { Pregunta: preg, Respuesta:false };
		this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));

		this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
			if(Respuesta == true){
				this.nota_credito_anulada.observacion = this.observacion.toString().trim();
				this.nota_credito_anulada.usuario_id = this.ss.getData("usuario_id");
				this.observacion  = "";

				this.loading = true;

				this.notaCreditoService.anular(this.nota_credito_anulada).subscribe(
					res => {
						this.bsModalRef.hide();
						this.nota_credito_anulada = new NotaCredito();

						this.msg.showMessage('success-message', 'Se ha procesado correctamente');

						this.getNotasCredito().then(
							res => {
								this.loading = false;
							},
							err => {
								this.loading = false;
							}
						);
					},
					err => {
						this.loading = false;
					}
				);
			}
			else{
				return;
			}
		});
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/compras/nota-credito-compra-list/nota-credito-compra-list.component.ts